export const translations = {
  en: {
    home: "Home", services: "Property Documents", verification: "Property Verification",
    calculators: "Calculators", registration: "Registration Services", rent: "Rent Agreement",
    estamping: "E-Stamping", garvi: "GARVI 2.0", blog: "Blog", contact: "Contact",
    login: "Login", get_started: "Get Started", dashboard: "Dashboard", logout: "Logout",
    hero_title: "Gujarat Property & Document Services, Now In One Place",
    hero_sub: "Get 7/12, 8-A, Ferfar, Property Card, Index-2, Certified Copy and other property services with ease.",
    find_document: "Find Document", verify_property: "Verify Property",
    search_title: "Search Property / Document",
    state: "State", district: "District", taluka: "Taluka", village: "Village", sro: "SRO",
    document_type: "Document Type", survey_number: "Survey Number", document_number: "Document Number",
    registration_year: "Registration Year", search: "Search",
    our_services: "Our Document Services",
    our_services_sub: "Request Gujarat property documents online — tracked end to end.",
    price: "Price", processing_time: "Processing time", required_info: "Required information",
    request_now: "Request Now", view_details: "View Details",
    packs_title: "Certified Document Packs", packs_sub: "Bundle services and save.",
    how_it_works: "How It Works",
    step1: "Choose your document or service", step2: "Enter property details & upload proofs",
    step3: "Pay securely online", step4: "Track status and download your document",
    why_title: "Why DocGalaxy",
    why1: "Private, secure document assistance",
    why2: "Transparent pricing, live order tracking",
    why3: "Rajkot-first team covering all 33 Gujarat districts",
    why4: "Gujarati + English support on WhatsApp and call",
    disclaimer_title: "Important Disclaimer",
    disclaimer_text: "DocGalaxy is a private digital assistance/service platform and is not a government website. Documents are retrieved through lawful channels; we do not claim government affiliation unless a specific government integration officially authorizes it.",
    verification_disclaimer: "Online verification is an information-assistance service and is not a substitute for independent legal advice or official government verification.",
    footer_tagline: "Property & Document Services",
    about: "About Us", privacy: "Privacy Policy", terms: "Terms & Conditions",
    refund: "Refund Policy", disclaimer: "Disclaimer", faq: "FAQ",
    my_orders: "My Orders", my_documents: "My Documents", my_verifications: "Verification Reports",
    payments: "Payments", profile: "Profile", support: "Support",
    status: "Status", track: "Track", download: "Download", invoice: "Invoice",
    govt_source: "Government source", assistance: "Document assistance service", verification_service: "Verification service",
  },
  gu: {
    home: "હોમ", services: "પ્રોપર્ટી દસ્તાવેજો", verification: "પ્રોપર્ટી વેરિફિકેશન",
    calculators: "કેલ્ક્યુલેટર", registration: "રજિસ્ટ્રેશન સેવાઓ", rent: "ભાડા કરાર",
    estamping: "ઈ-સ્ટેમ્પિંગ", garvi: "GARVI 2.0", blog: "બ્લોગ", contact: "સંપર્ક",
    login: "લોગિન", get_started: "શરૂ કરો", dashboard: "ડેશબોર્ડ", logout: "લોગઆઉટ",
    hero_title: "ગુજરાતની Property & Document Services હવે એક જ જગ્યાએ",
    hero_sub: "7/12, 8-A, ફેરફાર, Property Card, Index-2, Certified Copy અને અન્ય property services સરળતાથી મેળવો.",
    find_document: "Document શોધો", verify_property: "Property Verify કરો",
    search_title: "પ્રોપર્ટી / દસ્તાવેજ શોધો",
    state: "રાજ્ય", district: "જિલ્લો", taluka: "તાલુકો", village: "ગામ", sro: "SRO",
    document_type: "દસ્તાવેજ પ્રકાર", survey_number: "સર્વે નંબર", document_number: "દસ્તાવેજ નંબર",
    registration_year: "રજિસ્ટ્રેશન વર્ષ", search: "શોધો",
    our_services: "અમારી દસ્તાવેજ સેવાઓ",
    our_services_sub: "ગુજરાત પ્રોપર્ટી દસ્તાવેજો ઓનલાઇન માંગો — શરૂઆતથી ડિલિવરી સુધી ટ્રેકિંગ સાથે.",
    price: "કિંમત", processing_time: "પ્રક્રિયા સમય", required_info: "જરૂરી માહિતી",
    request_now: "વિનંતી કરો", view_details: "વિગત જુઓ",
    packs_title: "સર્ટિફાઇડ દસ્તાવેજ પેક", packs_sub: "સેવાઓ ભેગી કરો અને બચાવો.",
    how_it_works: "કેવી રીતે કામ કરે છે",
    step1: "તમારો દસ્તાવેજ અથવા સેવા પસંદ કરો", step2: "પ્રોપર્ટી વિગતો ભરો અને પુરાવા અપલોડ કરો",
    step3: "સુરક્ષિત ઓનલાઇન ચુકવણી કરો", step4: "સ્થિતિ ટ્રેક કરો અને દસ્તાવેજ ડાઉનલોડ કરો",
    why_title: "શા માટે DocGalaxy",
    why1: "ખાનગી, સુરક્ષિત દસ્તાવેજ સહાય સેવા",
    why2: "પારદર્શક કિંમતો, જીવંત ઓર્ડર ટ્રેકિંગ",
    why3: "રાજકોટ-ફર્સ્ટ ટીમ — ગુજરાતના તમામ 33 જિલ્લા",
    why4: "WhatsApp અને કોલ પર ગુજરાતી + English સપોર્ટ",
    disclaimer_title: "મહત્વની સૂચના",
    disclaimer_text: "DocGalaxy એક ખાનગી ડિજિટલ સહાય/સેવા પ્લેટફોર્મ છે અને સરકારી વેબસાઇટ નથી. દસ્તાવેજો કાનૂની માર્ગોથી મેળવવામાં આવે છે; અમે સરકારી સંલગ્નતાનો દાવો કરતા નથી.",
    verification_disclaimer: "ઓનલાઇન ચકાસણી એ માહિતી-સહાય સેવા છે અને તે સ્વતંત્ર કાનૂની સલાહ અથવા સત્તાવાર સરકારી ચકાસણીનો વિકલ્પ નથી.",
    footer_tagline: "પ્રોપર્ટી અને દસ્તાવેજ સેવાઓ",
    about: "અમારા વિશે", privacy: "ગોપનીયતા નીતિ", terms: "શરતો",
    refund: "રિફંડ નીતિ", disclaimer: "ડિસ્ક્લેમર", faq: "FAQ",
    my_orders: "મારા ઓર્ડર", my_documents: "મારા દસ્તાવેજો", my_verifications: "વેરિફિકેશન રિપોર્ટ",
    payments: "ચુકવણીઓ", profile: "પ્રોફાઇલ", support: "સપોર્ટ",
    status: "સ્થિતિ", track: "ટ્રેક", download: "ડાઉનલોડ", invoice: "ઇન્વૉઇસ",
    govt_source: "સરકારી સ્ત્રોત", assistance: "દસ્તાવેજ સહાય સેવા", verification_service: "ચકાસણી સેવા",
  },
};
